import { api } from '@/redux/api';
import { deviceApi } from '@/redux/api/endpoints/device';
import { selectUnitById } from '@/redux/api/seletors/select-unit-by-id';
import { AppGetState } from '@/redux/store';
import { QuerySuccessHandler } from '@/redux/types/query-success-handler';
import { addItemRecipe } from '@/redux/utils/add-item-recipe';
import { removeItemRecipe } from '@/redux/utils/remove-item-recipe';
import { updateItemRecipe } from '@/redux/utils/update-item-recipe';
import {
  DeviceAssociatedWithUnit,
  MaybeAssociatedDevice,
} from '@/types/device';
import { Unit } from '@/types/unit';
import { unitIdAndNameOnly } from '@/utils/unit-id-and-name-only';
import { getUnassociatedDevicesQueryParams } from '../../get-unassociated-devices';
import { AddDeviceToUnitQueryArg } from '../types/query-arg';

// TODO: fetch setup complete status?
export const dispatchSuccessPatchAddDeviceToUnit: QuerySuccessHandler<
  AddDeviceToUnitQueryArg
> = ({ device, unitId }, { dispatch, getState }) => {
  const { organisation } = device;
  const organisationId = organisation.id;

  const unit = selectUnitById(organisation, unitId)(getState());

  if (!unit) {
    throw new Error(`unit ${unitId} not found`);
  }

  const getUnassociatedDevicesQueryArg = getUnassociatedDevicesQueryParams(
    { organisationId },
    getState as AppGetState,
  );

  // Remove from list of unassociated devices
  dispatch(
    deviceApi.util.updateQueryData(
      'getUnassociatedDevices',
      getUnassociatedDevicesQueryArg,
      removeItemRecipe('id', device.id),
    ),
  );

  const associatedDevice: DeviceAssociatedWithUnit = {
    ...device,
    unit: unitIdAndNameOnly(unit),
  };

  // Add to list of associated devices in organisation
  dispatch(
    deviceApi.util.updateQueryData(
      'getAssociatedDevicesInOrganisation',
      { organisation },
      addItemRecipe(associatedDevice),
    ),
  );

  dispatch(
    deviceApi.util.updateQueryData(
      'getDevicesInOrganisation',
      { organisation },
      updateItemRecipe<MaybeAssociatedDevice, 'id'>('id', associatedDevice.id, {
        unit: associatedDevice.unit,
      }),
    ),
  );
  // Add to list of associated devices in unit
  dispatch(
    deviceApi.util.updateQueryData(
      'getAssociatedDevicesInUnit',
      { unit },
      addItemRecipe(associatedDevice),
    ),
  );

  const updatedDevicesList = [...unit.devices];
  updatedDevicesList.push({
    id: device.id,
  });

  // Add to unit.devices in unit
  dispatch(
    api.util.updateQueryData(
      'getUnits',
      { organisation },
      updateItemRecipe<Unit, 'id'>('id', unit.id, {
        devices: updatedDevicesList,
      }),
    ),
  );
};
